import { useState } from 'react';
import { testimonials } from '../../../mocks/products';

const TestimonialsSection = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="testimonios" className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 border border-gray-300 rounded-full mb-6">
            <span className="text-gray-700 text-sm font-light">Testimonios</span>
          </div>
          <h2 className="font-['Playfair_Display'] text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Lo Que Dicen<br />Nuestros Clientes
          </h2>
          <p className="text-gray-600 text-lg font-light max-w-xl mx-auto">
            Personas reales en Costa Rica que ya disfrutan de nuestros productos de distribuidores autorizados
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-3xl p-10 shadow-sm mb-8">
            <div className="flex items-center space-x-1 mb-6">
              {[...Array(testimonials[active].rating)].map((_, i) => (
                <div key={i} className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-[#D4AF37] text-lg"></i>
                </div>
              ))}
            </div>
            <p className="text-gray-700 text-lg font-light leading-relaxed mb-8 italic">
              "{testimonials[active].comment}"
            </p>
            <div className="flex items-center space-x-4">
              <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
                <img
                  src={testimonials[active].avatar}
                  alt={testimonials[active].name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div>
                <p className="text-gray-900 font-semibold text-base">{testimonials[active].name}</p>
                <p className="text-gray-500 text-sm font-light">{testimonials[active].location}</p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center space-x-3">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`transition-all duration-300 rounded-full cursor-pointer ${
                  i === active
                    ? 'w-8 h-3 bg-[#D4AF37]'
                    : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
